import { writable } from 'svelte/store';
export const externalDataState = writable({});